var map = {
	"./about-us-banner.webp": 216,
	"./anniversary-banner-bm.webp": 1588,
	"./anniversary-banner-cn.webp": 1589,
	"./anniversary-banner-id.webp": 1590,
	"./anniversary-banner.webp": 1591,
	"./banner-01.jpg": 1592,
	"./banner-slot.jpg": 1593,
	"./bet-and-earn-banner-cn.webp": 1594,
	"./bet-and-earn-banner-indon.webp": 1595,
	"./bet-and-earn-banner-ms.webp": 1596,
	"./bet-and-earn-banner.webp": 1597,
	"./check-in-banner-cn.webp": 1598,
	"./check-in-banner-id.webp": 1599,
	"./check-in-banner-ms.webp": 1600,
	"./check-in-banner.webp": 1601,
	"./cny_2024-bm.webp": 1602,
	"./cny_2024-cn.webp": 1603,
	"./cny_2024.webp": 1604,
	"./epl-banner-cn.jpg": 1605,
	"./epl-banner-cn.webp": 1606,
	"./epl-banner-indo.jpg": 1607,
	"./epl-banner-indo.webp": 1608,
	"./epl-banner-ms.jpg": 1609,
	"./epl-banner-ms.webp": 1610,
	"./epl-banner.jpg": 1611,
	"./epl-banner.webp": 1612,
	"./games-banner-cn.webp": 1613,
	"./games-banner-id.webp": 1614,
	"./games-banner-ms.webp": 1615,
	"./games-banner.webp": 1616,
	"./lb-m-banner-cn.webp": 1617,
	"./lb-m-banner.webp": 1618,
	"./leaderboard-banner-cn.webp": 1619,
	"./leaderboard-banner.webp": 1620,
	"./lottery-banner.webp": 1621,
	"./lottery-banners-cn.webp": 1622,
	"./lottery-banners-id.webp": 1623,
	"./lottery-banners-ms.webp": 1624,
	"./lottery-banners.webp": 1625,
	"./lucky-spin-banner-cn.webp": 1626,
	"./lucky-spin-banner-ms.webp": 1627,
	"./lucky-spin-banner-vn.webp": 1628,
	"./lucky-spin-banner.webp": 1629,
	"./p2p-banner.webp": 1630,
	"./p2p-banners-cn.webp": 1631,
	"./p2p-banners-id.webp": 1632,
	"./p2p-banners-ms.webp": 1633,
	"./p2p-banners.webp": 1634,
	"./premier-league-banner-cn.webp": 1635,
	"./premier-league-banner.webp": 1636,
	"./promos-banner-cn.webp": 1637,
	"./promos-banner-indon.webp": 1638,
	"./promos-banner-ms.webp": 1639,
	"./promos-banner.webp": 1640,
	"./promos-detail-banner.jpg": 1641,
	"./side-bar-banner.jpg": 1642,
	"./slot-banners-cn.webp": 1643,
	"./slot-banners-ms.webp": 1644,
	"./slot-banners.webp": 1645,
	"./speed-banners-cn.webp": 1646,
	"./speed-banners-ms.webp": 1647,
	"./speed-banners.webp": 1648,
	"./uefa24-prediction-bm.webp": 1649,
	"./uefa24-prediction-cn.webp": 1650,
	"./uefa24-prediction-id.webp": 1651,
	"./uefa24-prediction.webp": 1652,
	"./vip-banner-cn.webp": 1653,
	"./vip-banner-id.webp": 1654,
	"./vip-banner-ms.webp": 1655,
	"./vip-banner-vn.webp": 1656,
	"./vip-banner.webp": 1657,
	"./winner-leaderboard-banner-cn.webp": 1658,
	"./winner-leaderboard-banner.webp": 1659,
	"./world-cup-banner-cn.webp": 1660,
	"./world-cup-banner.webp": 1661,
	"./world-cup-two-banner-cn.webp": 1662,
	"./world-cup-two-banner.webp": 1663,
	"./xmas_2023-bm.jpg": 1664,
	"./xmas_2023-cn.jpg": 1665,
	"./xmas_2023-id.jpg": 1666,
	"./xmas_2023.jpg": 1667,
	"./xmas_2024-bm.webp": 1668,
	"./xmas_2024-cn.webp": 1669,
	"./xmas_2024.webp": 1670
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48;